import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { format, isSameYear, fromUnixTime } from 'date-fns';
import { enUS, ru, pl, es, kk, bg } from 'date-fns/locale';

/**
 * Vue composable providing localized time formatting utilities.
 * Automatically reacts to locale changes from vue-i18n.
 */
export function useTimeHelper() {
  const { locale } = useI18n();

  const locales = { en: enUS, ru, pl, es, kk, bg };

  // helper — вычисляет локаль date-fns из текущей i18n локали
  const currentLocale = computed(() => {
    const code = locale.value?.split('-')[0] || 'en';
    return locales[code] || enUS;
  });

  const messageStamp = (time, dateFormat = 'HH:mm') => {
    const unixTime = fromUnixTime(time);
    return format(unixTime, dateFormat, { locale: currentLocale.value });
  };

  const messageTimestamp = (time, dateFormat = 'MMM d, yyyy') => {
    const messageTime = fromUnixTime(time);
    const now = new Date();
    const messageDate = format(messageTime, dateFormat, {
      locale: currentLocale.value,
    });
    if (!isSameYear(messageTime, now)) {
      return format(messageTime, 'LLL d y, h:mm a', {
        locale: currentLocale.value,
      });
    }
    return messageDate;
  };

  const dateFormatFn = (time, df = 'MMM d, yyyy') => {
    const unixTime = fromUnixTime(time);
    return format(unixTime, df, { locale: currentLocale.value });
  };

  return {
    messageStamp,
    messageTimestamp,
    dateFormat: dateFormatFn,
  };
}
